(() => {
  if (!document.body.matches('.template-collection.product-card-layout-02')) return;

  let frame = 0;
  let observedGrids = [];
  const resizeObserver = new ResizeObserver(() => schedule());

  function align() {
    frame = 0;
    const grids = [...document.querySelectorAll('.productListing.productGrid')];
    if (grids.length !== observedGrids.length || grids.some((grid, index) => grid !== observedGrids[index])) {
      resizeObserver.disconnect();
      grids.forEach((grid) => resizeObserver.observe(grid));
      observedGrids = grids;
    }

    document.querySelectorAll('.productListing .card-title, .productListing .card-price').forEach((element) => {
      element.style.removeProperty('--mr-card-row-title-height');
      element.style.removeProperty('--mr-card-row-price-height');
    });

    grids.forEach((grid) => {
      const rows = [];
      [...grid.children].filter((item) => item.matches('.product') && item.offsetParent !== null).forEach((item) => {
        const title = item.querySelector('.card-information > .card-information__wrapper .card-title');
        const price = item.querySelector('.card-information > .card-information__wrapper .card-price');
        let row = rows.find((candidate) => Math.abs(candidate.top - item.offsetTop) <= 2);
        if (!row) {
          row = { top: item.offsetTop, cards: [] };
          rows.push(row);
        }
        row.cards.push({ title, price, titleHeight: title?.getBoundingClientRect().height || 0, priceHeight: price?.getBoundingClientRect().height || 0 });
      });

      rows.forEach((row) => {
        if (row.cards.length < 2) return;
        const titleHeight = Math.max(...row.cards.map((card) => card.titleHeight));
        const priceHeight = Math.max(...row.cards.map((card) => card.priceHeight));
        row.cards.forEach(({ title, price }) => {
          title?.style.setProperty('--mr-card-row-title-height', `${titleHeight}px`);
          price?.style.setProperty('--mr-card-row-price-height', `${priceHeight}px`);
        });
      });
    });
  }

  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(align);
    });
  }

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.type === 'childList' || mutation.target.matches('.productListing'))) schedule();
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', (event) => {
    if (event.target instanceof Element && event.target.closest('.productListing')) schedule();
  }, true);
  document.fonts?.ready.then(schedule);
  schedule();
})();
